export enum LocalStorageKeys {
  HasUsedHelp = "HasUsedHelp",
}

export const getFromLocalStorage = (key: LocalStorageKeys) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : undefined;
};

export const setInLocalStorage = (key: LocalStorageKeys, value: any) => {
  if (value) {
    try {
      const data = JSON.stringify(value);
      data && localStorage.setItem(key, data);
      return data ? value : undefined;
    } catch (e) {
      return undefined;
    }
  }
};
